<template>
  <div class="card card-info">
    <div class="card-header with-border">
      <h3 class="card-title"></h3>
      <button type="button" class="btn btn-primary" style="float: left" v-on:click="changestate()">+Add New</button>
    </div>
    <!-- /.box-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-12">
          <table class="table table-bordered table-color" id="table">
            <thead class="bg-info">
              <tr>
                <th>Sr. No.</th>
                <th>Student Name</th>
                <th>Father Name</th>
                <th>Roll No</th>
                <th>Previous Status</th>
                <th>Current Status</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in detail">
                <td>{{ind+1}}</td>
                <td>{{item.Name}}</td>
                <td>{{item.FathersName}}</td>
                <td>{{item.RollNo}}</td>
                <td v-if="item.PreviousStatus">Active</td>
                <td v-if="!item.PreviousStatus">InActive</td>
                <td v-if="item.CurrentStatus">Active</td>
                <td v-if="!item.CurrentStatus">InActive</td>
                <td>{{item.Remarks}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {

        detail: [],
      }
    },
    created: function () {
      this.loadstudentactivedetail();
    },

    updated: function () {
      $('#table').DataTable();
    },
    methods: {

      changestate() {
        window.location.href = '/DC/StudentActiveInActive'
       
      },

      loadstudentactivedetail() {
        var vm = this;
        axios.post('/api/DCApi/loadstudentactivedetail')
          .then(function (response) {
            vm.detail = response.data.lst;
          })
          .catch(function (error) {
            console.log(error);
          });
      },



    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/allStudentActiveInActive.vue